import { BrandColors } from "@/constants/theme";
import { useAuth } from "@/contexts/auth-context";
import { useDesktopLayout } from "@/hooks/use-desktop-layout";
import Ionicons from "@react-native-vector-icons/ionicons";
import { router } from "expo-router";
import React from "react";
import { StyleSheet, TouchableOpacity, View, ViewStyle } from "react-native";
import { ThemedText } from "../themed-text";
import { MenuBar } from "./MenuBar";

interface ScreenHeaderProps {
  title: string;
  subtitle?: string;
  style?: ViewStyle;
  rightComponent?: React.ReactNode;
  showMenu?: boolean;
  onBack?: () => void;
}

export const ScreenHeader: React.FC<ScreenHeaderProps> = ({
  title,
  subtitle,
  style,
  rightComponent,
  showMenu = true,
  onBack,
}) => {
  const { theme } = useAuth();
  const desktop = useDesktopLayout();
  const showDrawerMenu = showMenu && !desktop;

  return (
    <View style={[styles.header, { backgroundColor: theme.background }, style]}>
      {showDrawerMenu ? (
        <MenuBar style={styles.top} />
      ) : showMenu ? (
        <View style={[styles.top, styles.menuSpacer]} />
      ) : (
        <TouchableOpacity
          style={styles.top}
          onPress={onBack ?? (() => router.back())}
        >
          <Ionicons name="chevron-back" size={24} color={theme.text} />
        </TouchableOpacity>
      )}
      <View style={styles.titleContainer}>
        <ThemedText style={styles.headerTitle}>{title}</ThemedText>
        {subtitle && (
          <ThemedText style={styles.headerSubtitle}>{subtitle}</ThemedText>
        )}
      </View>
      <View
        style={{ width: 44, alignItems: "flex-end", justifyContent: "center" }}
      >
        {rightComponent}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: "700",
  },
  titleContainer: {
    alignItems: "center",
  },
  headerSubtitle: {
    fontSize: 12,
    color: BrandColors.mediumGray,
    marginTop: 2,
  },
  top: {
    position: "relative",
    top: 0,
    left: 0,
  },
  menuSpacer: {
    width: 44,
    height: 44,
  },
});
